import { render, staticRenderFns } from "./Riskmatrixwithpoint.vue?vue&type=template&id=3bc39b1b&scoped=true"
import script from "./Riskmatrixwithpoint.vue?vue&type=script&lang=js"
export * from "./Riskmatrixwithpoint.vue?vue&type=script&lang=js"
import style0 from "./Riskmatrixwithpoint.vue?vue&type=style&index=0&id=3bc39b1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc39b1b",
  null
  
)

export default component.exports